
import Vue, { PropType } from 'vue';

export default Vue.extend({
    props: {
        value: {
            type: Number as PropType<number>,
            required: true
        },
        min: {
            type: Number as PropType<number>,
            default: 0
        },
        max: {
            type: Number as PropType<number>,
            default: 0
        },
        step: {
            type: Number as PropType<number>,
            default: 1
        },
        ariaLabel: {
            type: String as PropType<string>,
            default: undefined
        }
    },

    data() {
        return {
            sliderEl: null as unknown as HTMLInputElement,
        };
    },

    computed: {
        rangeProgressStyle(): unknown {
            if (!this.max) {
                return null;
            }

            const progress = ((this.value - this.min) / (this.max - this.min)) * 100;
            return {
                background: `linear-gradient(
                        to right,
                        white 0%,
                        white ${progress}%,
                        rgba(255,255,255,0.3) ${progress}%,
                        rgba(255,255,255,0.3) 100%)`
            };
        }
    },

    mounted() {
        this.sliderEl = this.$refs.slider as HTMLInputElement;
    },

    methods: {
        onInputChanged() {
            const newValue = Number.parseFloat(this.sliderEl.value);
            this.$emit('input', newValue);
        }
    }
});
